import dayjs from 'dayjs'
import request from '../utils/request'
import vtag from '@/components/vtag'
import vimagetooltip from '@/components/vimagetooltip'
import vupload1 from '@/components/vupload1'
export default function (Vue) {
  // 请求方法
  Vue.prototype.$axios = request
  // 日期方法
  Vue.prototype.$dayjs = dayjs

  // 组件
  // tag状态组件
  Vue.component('vtag', vtag)
  // 图片预览组件
  Vue.component('vimagetooltip', vimagetooltip)
  // 单张图片上传组件
  Vue.component('vupload1', vupload1)

  Vue.mixin({
    methods: {
      // 按钮权限
      // buttonName 按钮名
      buttonPermission (buttonName) {
        const pathButtonList = this.$store.getters.buttonPermission || []
        return !pathButtonList.includes(buttonName)
      },
      // 时间戳格式化
      vtimeFormat (time) {
        if (time) {
          if ((time + '').length === 10) {
            return dayjs(time * 1000).format('YYYY-MM-DD HH:mm:ss')
          } else {
            return dayjs(time).format('YYYY-MM-DD HH:mm:ss')
          }
        } else {
          return ''
        }
      }
    }
  })
}
